module.exports = __webpack_public_path__ + "img/Jump Casting37.bbe0dcee.jpg";